import { theme } from '../../../../ThemeContext/ThemeObject';
import { sharedClasses } from '../../../Components/CustomUIElements/sharedClasses';
import {
  pagination,
  paginationContainer,
  rowSelect,
  rowSelectContainer
} from '../../../shared/styleClasses';

export const classes = {
  tableWrapper: {
    tableLayout: 'auto !important',
    // minWidth: '1000px',
    border: 'none',
    'td, th, tr, thead': {
      fontFamily: 'Source Sans Pro, sans-serif',
      border: 'none',
      backgroundColor: '#FFFFFF',
      textTransform: 'none',
      padding: '12px 0px 12px 4px'
    },
    th: {
      color: theme.palette.primary.main,
      fontSize: '14px',
      fontWeight: 'bold',
      paddingBottom: '5px'
    }
  },
  fileIconContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  fileIcon: {
    minWidth: '50px',
    minHeight: '50px',
    borderRadius: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#084D6D10',
    '& svg': {
      color: theme.palette.primary.main,
      margin: '0px 2px 2px 0px'
    }
  },
  fileDate: {
    color: theme.palette.primary.main,
    fontSize: '14px',
    fontWeight: 'bold'
  },
  fileName: {
    color: '#999999'
  },
  fileLinkContainer: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '14px',
    '& a': {
      color: '#333333',
      fontSize: '14px',
      '&:hover': {
        color: '#000000',
        textDecoration: 'none'
      }
    }
  },
  fileAttachedBy: {
    color: '#000000',
    fontSize: '14px'
  },
  copyButton: {
    fontSize: '10px',
    fontWeight: 'bold',
    backgroundColor: '#5BC4BF1F',
    color: theme.palette.action.main,
    borderRadius: '6px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.action.main,
      color: '#FFFFFF'
    }
  },
  noAttachments: {
    ...sharedClasses.noContentWrapper
  },
  paginationParent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '20px'
  },
  rowSelectContainer,
  paginationContainer,
  pagination,
  rowSelect,
  paginationMenuItems: {
    '& li': {
      fontFamily: 'Source Sans Pro'
    }
  }
};
